var map = {
	"../leave-module-new/leave-new.module": [
		"./src/app/leave-module-new/leave-new.module.ts",
		"leave-module-new-leave-new-module"
	],
	"./attendance/attendance.module": [
		"./src/app/attendance/attendance.module.ts"
	],
	"./calendar/calendar.module": [
		"./src/app/calendar/calendar.module.ts"
	],
	"./central/central.module": [
		"./src/app/reports/statutory/central/central.module.ts"
	],
	"./coff-approval-process/coff-approval-process.module": [
		"./src/app/coff-approval-process/coff-approval-process.module.ts"
	],
	"./communication/communication.module": [
		"./src/app/communication/communication.module.ts",
		"communication-communication-module"
	],
	"./company-commons-master/company-commons-master.module": [
		"./src/app/company-commons-master/company-commons-master.module.ts",
		"common",
		"company-commons-master-company-commons-master-module"
	],
	"./compliance-reports/compliance-reports.module": [
		"./src/app/reports/compliance-reports/compliance-reports.module.ts",
		"default~compliance-reports-compliance-reports-module~rpt-licence-expiry-rpt-licence-expiry-module",
		"common",
		"compliance-reports-compliance-reports-module"
	],
	"./contractor-master/contractor-master.module": [
		"./src/app/reports/contractor-master/contractor-master.module.ts",
		"contractor-master-contractor-master-module"
	],
	"./contractor/contractor.module": [
		"./src/app/contractor/contractor.module.ts"
	],
	"./core/components/syncfusion-pivot-table/syncfusion-ej2.module": [
		"./src/app/core/components/syncfusion-pivot-table/syncfusion-ej2.module.ts",
		"core-components-syncfusion-pivot-table-syncfusion-ej2-module"
	],
	"./daily-attendance/daily-attendance.module": [
		"./src/app/reports/daily-attendance/daily-attendance.module.ts",
		"default~daily-attendance-daily-attendance-module~gatepass-reports-gatepass-reports-module~print-gate~bdf29f4a",
		"default~daily-attendance-daily-attendance-module~mis-reports-mis-reports-module~payroll-payroll-modu~df859c09",
		"default~daily-attendance-daily-attendance-module~payroll-payroll-module",
		"common",
		"daily-attendance-daily-attendance-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts"
	],
	"./gatepass-reports/gatepass-reports.module": [
		"./src/app/reports/gatepass-reports/gatepass-reports.module.ts",
		"default~daily-attendance-daily-attendance-module~gatepass-reports-gatepass-reports-module~print-gate~bdf29f4a",
		"common",
		"gatepass-reports-gatepass-reports-module"
	],
	"./global-setting/global-setting.module": [
		"./src/app/global-setting/global-setting.module.ts"
	],
	"./group-wise-component/group-wise-component.module": [
		"./src/app/payroll/group-wise-component/group-wise-component.module.ts",
		"group-wise-component-group-wise-component-module"
	],
	"./hr-clearance-demo/hr-clearance.module": [
		"./src/app/hr-clearance-demo/hr-clearance.module.ts",
		"hr-clearance-demo-hr-clearance-module"
	],
	"./hr-clearance/hr-clearance.module": [
		"./src/app/hr-clearance/hr-clearance.module.ts"
	],
	"./labour/labour.module": [
		"./src/app/labour/labour.module.ts"
	],
	"./leave-module-new/leave-new.module": [
		"./src/app/leave-module-new/leave-new.module.ts",
		"leave-module-new-leave-new-module"
	],
	"./leave-module/leave.module": [
		"./src/app/leave-module/leave.module.ts"
	],
	"./loan-and-recoveries/loan-and-recoveries.module": [
		"./src/app/payroll/loan-and-recoveries/loan-and-recoveries.module.ts",
		"loan-and-recoveries-loan-and-recoveries-module"
	],
	"./loan-n-recoveries-register-from-c/loan-n-recoveries-register-from-c.module": [
		"./src/app/reports/statutory/central/loan-n-recoveries-register-from-c/loan-n-recoveries-register-from-c.module.ts"
	],
	"./man-power-yearly/man-power-yearly.module": [
		"./src/app/man-power-yearly/man-power-yearly.module.ts"
	],
	"./man-power/man-power.module": [
		"./src/app/man-power/man-power.module.ts"
	],
	"./master-module/master-module.module": [
		"./src/app/master-module/master-module.module.ts",
		"common",
		"master-module-master-module-module"
	],
	"./min-wage-configuration-component/min-wage-configuration-component.module": [
		"./src/app/payroll/min-wage-configuration-component/min-wage-configuration-component.module.ts",
		"common",
		"min-wage-configuration-component-min-wage-configuration-component-module"
	],
	"./min-wage-master/min-wage-master.module": [
		"./src/app/payroll/min-wage-master/min-wage-master.module.ts",
		"common",
		"min-wage-master-min-wage-master-module"
	],
	"./mis-reports/mis-reports.module": [
		"./src/app/reports/mis-reports/mis-reports.module.ts",
		"default~daily-attendance-daily-attendance-module~mis-reports-mis-reports-module~payroll-payroll-modu~df859c09",
		"default~mis-reports-mis-reports-module~reports-reports-module",
		"common",
		"mis-reports-mis-reports-module"
	],
	"./pay-slip/pay-slip.module": [
		"./src/app/reports/statutory/central/pay-slip/pay-slip.module.ts"
	],
	"./payroll/payroll.module": [
		"./src/app/payroll/payroll.module.ts",
		"default~daily-attendance-daily-attendance-module~mis-reports-mis-reports-module~payroll-payroll-modu~df859c09",
		"default~daily-attendance-daily-attendance-module~payroll-payroll-module",
		"common",
		"payroll-payroll-module"
	],
	"./policy/policy.module": [
		"./src/app/policy/policy.module.ts"
	],
	"./print-gate-pass/print-gate-pass.module": [
		"./src/app/labour/print-gate-pass/print-gate-pass.module.ts",
		"default~daily-attendance-daily-attendance-module~gatepass-reports-gatepass-reports-module~print-gate~bdf29f4a",
		"common",
		"print-gate-pass-print-gate-pass-module"
	],
	"./reference-control/reference-control.module": [
		"./src/app/reference-control/reference-control.module.ts",
		"reference-control-reference-control-module"
	],
	"./report/report.module": [
		"./src/app/report/report.module.ts"
	],
	"./reports/daily-attendance/daily-attendance.module": [
		"./src/app/reports/daily-attendance/daily-attendance.module.ts",
		"default~daily-attendance-daily-attendance-module~gatepass-reports-gatepass-reports-module~print-gate~bdf29f4a",
		"default~daily-attendance-daily-attendance-module~mis-reports-mis-reports-module~payroll-payroll-modu~df859c09",
		"default~daily-attendance-daily-attendance-module~payroll-payroll-module",
		"common",
		"daily-attendance-daily-attendance-module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"default~mis-reports-mis-reports-module~reports-reports-module",
		"common",
		"reports-reports-module"
	],
	"./requirement-mandays/requirement-mandays.module": [
		"./src/app/reports/daily-attendance/requirement-mandays/requirement-mandays.module.ts",
		"requirement-mandays-requirement-mandays-module"
	],
	"./rpt-licence-expiry/rpt-licence-expiry.module": [
		"./src/app/reports/compliance-reports/rpt-licence-expiry/rpt-licence-expiry.module.ts",
		"default~compliance-reports-compliance-reports-module~rpt-licence-expiry-rpt-licence-expiry-module",
		"common"
	],
	"./shift/shift.module": [
		"./src/app/shift/shift.module.ts"
	],
	"./statutory/statutory.module": [
		"./src/app/reports/statutory/statutory.module.ts",
		"statutory-statutory-module"
	],
	"./user-management/user-management.module": [
		"./src/app/user-management/user-management.module.ts"
	],
	"./visitor-management/visitor-management.module": [
		"./src/app/visitor-management/visitor-management.module.ts"
	],
	"./yearly-budget/yearly-budget.module": [
		"./src/app/yearly-budget/yearly-budget.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;